import './plugins/zoom-ui'
import router from './plugins/router'
import App from './App.vue'
import './styles/sidebar.scss'
import './permission' // permission control
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import VCharts from 'v-charts'
Vue.use(VCharts)
Vue.use(VueClipboard)

// const Vue = window.Vue
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
